import {
  IApplicationsForSolfinProps,
  IPreDisburseApplicationProps,
} from '../../types/application';

import {
  LmsAgentApplicationRoute,
  useLmsAgentRouter,
} from '../../LMSAgent/Provider/LmsAgentRouter';
import ApplicationReview, {
  ViewSource,
} from '../../LMSAgent/components/ApplicationReview/ApplicationReview';
import Pre_Disbursement from './Pre_Disbursement';

export interface IApplicationsProps {
  loading: boolean;
  page: number;
  totalPages: number;
  applicationData: IApplicationsForSolfinProps[];
}
export interface IPre_DisburseApplicationsProps {
  loading: boolean;
  page: number;
  totalPages: number;
  applicationData: IPreDisburseApplicationProps[];
}

const PreDisbusermentDashboardHQ = () => {
  const { selectedRoute, navigateToApplicationHome } = useLmsAgentRouter();

  if (selectedRoute == LmsAgentApplicationRoute.Applications) {
    return <Pre_Disbursement />;
  } else if (selectedRoute == LmsAgentApplicationRoute.ApplicationReview) {
    return <ApplicationReview viewSource={ViewSource.HqPredisbursement} />;
  }

  navigateToApplicationHome();

  return <></>;
};

export default PreDisbusermentDashboardHQ;
